import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Card, CardContent, Grid, Paper } from "@material-ui/core";
import {
  renderCheckbox,
  renderMultiLineTextField,
} from "components/form-global-components/components-form-components-for-react-final-form";
class FormFieldsTabAllClinicalProviders extends Component {
  render() {
    return (
      <div>
        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>

{/* 
                                                                                    <Grid item xs={12}>
                                                                                      <InputLabel>
                                                                                        Clinical Providers at Referral
                                                                                      </InputLabel>
                                                                                    </Grid>
*/}

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersnone"
                    name="clinicalprovidersnone"
                    objName="clinicalprovidersnone"
                    label="None"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersctssa"
                    name="clinicalprovidersctssa"
                    objName="clinicalprovidersctssa"
                    label="CTS-SA"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersctsmh"
                    name="clinicalprovidersctsmh"
                    objName="clinicalprovidersctsmh"
                    label="CTS-MH"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalproviderschcs"
                    name="clinicalproviderschcs"
                    objName="clinicalproviderschcs"
                    label="CHCS"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalproviderschcsmat"
                    name="clinicalproviderschcsmat"
                    objName="clinicalproviderschcsmat"
                    label="CHCS (MAT)"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersnewseasonsmat"
                    name="clinicalprovidersnewseasonsmat"
                    objName="clinicalprovidersnewseasonsmat"
                    label="New Seasons (MAT)"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersmedmarkmat"
                    name="clinicalprovidersmedmarkmat"
                    objName="clinicalprovidersmedmarkmat"
                    label="MedMark (MAT)"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersstccteam"
                    name="clinicalprovidersstccteam"
                    objName="clinicalprovidersstccteam"
                    label="STCC Team"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersrosettakeys"
                    name="clinicalprovidersrosettakeys"
                    objName="clinicalprovidersrosettakeys"
                    label="Rosetta Keys"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalproviderselitecounseling"
                    name="clinicalproviderselitecounseling"
                    objName="clinicalproviderselitecounseling"
                    label="Elite Counseling"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id="clinicalprovidersotherprovider"
                    name="clinicalprovidersotherprovider"
                    objName="clinicalprovidersotherprovider"
                    label="Other Provider"
                    footerMessage=""
                  />
                </Grid>

                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id="clinicalproviderscomments"
                    name="clinicalproviderscomments"
                    label="Clinical Providers Comments"
                    rows="6"
                    emptyText="Your comments should be clear and concise."
                    footerMessage="Your comments should be clear and concise."
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </div>
    );
  }
}
FormFieldsTabAllClinicalProviders.propTypes = {
  locked: PropTypes.bool,
};
export default FormFieldsTabAllClinicalProviders;
